import {
  LanguageTestTemplate,
  LanguageTestTemplateInput
} from '../../lib/types/models/language-test/language-test-template'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateLanguageTestTemplate = ({
  id,
  ...rest
}: UpdateInput<LanguageTestTemplateInput>) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.updateTemplate.url, { id }))
    .patch<LanguageTestTemplate, Partial<LanguageTestTemplateInput>>(rest)
